"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFloatORNull = exports.formattedNumberToStringVal = exports.roundedNumber = exports.formattedNumberWithCommas = void 0;
const formattedNumberWithCommas = (number) => {
    const rounded = (0, exports.roundedNumber)(number, 2);
    const isInteger = rounded % 1 === 0;
    const decimalPlace = isInteger ? 0 : 2;
    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: decimalPlace,
        maximumFractionDigits: decimalPlace,
    }).format(rounded);
};
exports.formattedNumberWithCommas = formattedNumberWithCommas;
const roundedNumber = (number, decimalPlace = 1) => {
    const divide = Math.pow(10, decimalPlace);
    return number ? Math.round(number * divide) / divide : 0;
};
exports.roundedNumber = roundedNumber;
const formattedNumberToStringVal = (val) => {
    if (val === 0)
        return "0";
    return val ? val.toString() : "";
};
exports.formattedNumberToStringVal = formattedNumberToStringVal;
function parseFloatORNull(value) {
    return (value || value === 0) && value !== "" ? parseFloat(`${value}`) : null;
}
exports.parseFloatORNull = parseFloatORNull;
//# sourceMappingURL=numberUtils.js.map